import React from 'react'

import SingleFacebookComment from './SingleFacebookComment'
import { Grid } from '@mui/material'
import { IPostElementProps } from '../../../../../types/types'
import SingleInstagramComment from './SingleInstagramComment'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import SingleLinkedInComment from './SingleLinkedInComment'

const Comments: React.FC<IPostElementProps> = (props) => {
  const comments: [] = props.post?.comments
  return (
    <>
      {comments && comments.map((comment: any, index) => {
        return (
          <div key={index}>
            {props.networkType === NetworkType.Facebook && props.networkPageId &&
              <SingleFacebookComment networkPageId={props.networkPageId} post={props.post} comment={comment} networkType={props.networkType} onChange={props.onChange} />}
            {props.networkType === NetworkType.Instagram && props.networkPageId &&
              <SingleInstagramComment networkPageId={props.networkPageId} post={props.post} comment={comment} networkType={props.networkType} onChange={props.onChange} />}
            {props.networkType === NetworkType.LinkedIn && props.networkPageId &&
              <SingleLinkedInComment profileImage={props.value} networkPageId={props.networkPageId} post={props.post} comment={comment} networkType={props.networkType} onChange={props.onChange} />}
            <Grid container item xs={12}>
              {comment.replies && comment.replies.map((reply: any, i: number) => {
                return (
                  <div key={i}>
                    {props.networkType === NetworkType.Facebook && props.networkPageId &&
                      <SingleFacebookComment networkPageId={props.networkPageId} post={props.post} comment={reply} networkType={props.networkType} onChange={props.onChange} />}
                    {props.networkType === NetworkType.Instagram && props.networkPageId &&
                      <SingleInstagramComment networkPageId={props.networkPageId} post={props.post} comment={reply} networkType={props.networkType} onChange={props.onChange} />}
                    {props.networkType === NetworkType.LinkedIn && props.networkPageId &&
                      <SingleLinkedInComment profileImage={props.value} networkPageId={props.networkPageId} post={props.post} comment={reply} networkType={props.networkType} onChange={props.onChange} />}
                  </div>
                )
              })}
            </Grid>
          </div>
        )
      })}
    </>
  )
}

export default Comments
